import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Menu as MenuIcon, X } from "lucide-react";
import { NavLogo, DesktopNav, DesktopCTA, MobileMenu } from "./NavbarParts";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const onScroll = useCallback(() => setScrolled(window.scrollY > 30), [setScrolled]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, setOpen]);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled && !open;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        transparent ? "bg-transparent" : "bg-[#0d2929]/95 backdrop-blur-md shadow-lg shadow-black/10"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 flex items-center justify-between h-20 lg:h-24">
        <NavLogo />
        <DesktopNav />
        <DesktopCTA />
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <MenuIcon size={24} />}
        </button>
      </div>
      <MobileMenu open={open} />
    </header>
  );
}
